import { TYPOGRAPHY } from "../../theme/typography";
import { PluginCreator } from "tailwindcss/types/config";

const textPlugin: PluginCreator = ({
  addUtilities,
}: {
  addUtilities: Function;
  theme: Function;
}) => {
  const newUtilities = {} as any;

  const keys = Object.keys(TYPOGRAPHY) as string[];

  keys.forEach((key) => {
    // @ts-ignore
    const styles = TYPOGRAPHY[key];

    const sharedStyles = {
      fontWeight: styles.fontWeight,
      fontFamily: styles.fontFamily,
    };

    newUtilities[`.text-${key}-lg`] = {
      ...sharedStyles,
      fontSize: styles.large.fontSize,
      lineHeight: styles.large.lineHeight,
      letterSpacing: styles.large.letterSpacing,
    };

    newUtilities[`.text-${key}-md`] = {
      ...sharedStyles,
      fontSize: styles.medium.fontSize,
      lineHeight: styles.medium.lineHeight,
      letterSpacing: styles.medium.letterSpacing,
    };

    newUtilities[`.text-${key}-sm`] = {
      ...sharedStyles,
      fontSize: styles.small.fontSize,
      lineHeight: styles.small.lineHeight,
      letterSpacing: styles.small.letterSpacing,
    };
  });

  addUtilities(newUtilities, ["responsive", "hover"]);
};

export default textPlugin;
